export default {
  en: {
    turns: {
      title: 'Sign in to keep talking',
      body: 'Your conversations, progress and statistics stay with you — on all your devices.',
    },
    pay: {
      title: 'Sign in to subscribe',
      body: 'So your subscription is tied to your account and works on any device.',
    },
    save: {
      title: 'Save your progress',
      body: 'Your conversations, progress and statistics stay with you — on all your devices.',
    },
  },
  ru: {
    turns: {
      title: 'Войди, чтобы продолжить разговор',
      body: 'Разговоры, прогресс и статистика останутся с тобой — на всех твоих устройствах.',
    },
    pay: {
      title: 'Войди, чтобы оформить подписку',
      body: 'Так подписка будет привязана к твоему аккаунту и заработает на любом устройстве.',
    },
    save: {
      title: 'Сохрани свой прогресс',
      body: 'Разговоры, прогресс и статистика останутся с тобой — на всех твоих устройствах.',
    },
  },
};
